import { makeLoginValidation } from "../../../main/factories/validation";
import { makeRemoteAuthentication } from "../../../main/factories/usecases";
import { Login } from "../../../presentation/pages/Login";

import React from "react";

export const makeLogin = () => {
  return (
    <Login
      authentication={makeRemoteAuthentication()}
      validation={makeLoginValidation()}
    />
  );
};
